import axios from "axios";

const URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002'; // Fallback to localhost if not set
// User API functions   

export async function createPerson(payload, token) {
  try {
    if (!token) throw new Error("Token is required");
    if (!payload?.type || !payload?.firstName || !payload?.lastName) {
      throw new Error("type, firstName and lastName are required to create a person");
    }

    const response = await axios.post(`${URL}/people/create`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 201 || response.status === 200) {
      return response.data; // { message, insertedId }
    } else {
      throw new Error(response.data?.message || "Failed to create person");
    }
  } catch (error) {
    console.error("❌ Error creating person:", error?.message || error);
    throw error;
  }
}

export async function updatePerson(personId, payload, token) {
  try {
    if (!token) throw new Error("Token is required");
    if (!personId) throw new Error("personId is required to update a person");
    if (!payload || typeof payload !== "object") {
      throw new Error("payload is required to update a person");
    }

    const response = await axios.post(`${URL}/people/update/${personId}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 201 || response.status === 200) {
      return response.data; // { message, modifiedCount }
    } else {
      throw new Error(response.data?.message || "Failed to update person");
    }
  } catch (error) {
    console.error("❌ Error updating person:", error?.message || error);
    throw error;
  }
}

export async function deletePerson(personId, token) {
  try {
    if (!token) throw new Error("Token is required");
    if (!personId) throw new Error("personId is required to delete a person");

    const response = await axios.post(
      `${URL}/people/delete/${personId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.status === 200 || response.status === 201) {
      return response.data; // { message, deletedCount }
    } else {
      throw new Error(response.data?.message || "Failed to delete person");
    }
  } catch (error) {
    console.error("❌ Error deleting person:", error?.message || error);
    throw error;
  }
}

export async function getPeopleForUser(token) {
  try {
    if (!token) throw new Error("Token is required");

    const response = await axios.get(`${URL}/people/user`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 200) {
      return response.data; // array of people
    } else {
      throw new Error(response.data?.message || "Failed to retrieve people");
    }
  } catch (error) {
    console.error("❌ Error retrieving people for user:", error?.message || error);
    throw error;
  }
}
